import { createComponent } from '@lit-labs/react';
import React from 'react';

import { OnChatGroupClient as OnChatGroupClientWC } from '../../web-components/group-client/group-client';

const OnChatGroupClient = createComponent(
  React,
  'on-chat-group-client',
  OnChatGroupClientWC
);

export default OnChatGroupClient;
